/**
 * Disable Organisation constants
 */

export const i18nKeys = {
  TITLE: 'systemSettings.disableOrganization.title',
  EXPLANATION: {
    TITLE: 'systemSettings.disableOrganization.explanation.title',
    BODY: 'systemSettings.disableOrganization.explanation.body',
    USE_FOR: 'systemSettings.disableOrganization.explanation.useFor',
    DO_NOT_USE: 'systemSettings.disableOrganization.explanation.doNotUse',
    IRREVERSIBLE: 'systemSettings.disableOrganization.explanation.irreversible'
  },
  FORM: {
    ORG_ID_LABEL: 'systemSettings.disableOrganization.form.orgIdLabel',
    ORG_ID_PLACEHOLDER: 'systemSettings.disableOrganization.form.orgIdPlaceholder',
    LOAD_BUTTON: 'systemSettings.disableOrganization.form.loadButton',
    CLEAR_BUTTON: 'systemSettings.disableOrganization.form.clearButton',
    VALIDATION_INVALID_ID: 'systemSettings.disableOrganization.form.validationInvalidId'
  },
  DETAILS: {
    TITLE: 'systemSettings.disableOrganization.details.title',
    ID: 'systemSettings.disableOrganization.details.id',
    NAME: 'systemSettings.disableOrganization.details.name',
    CREATED_AT: 'systemSettings.disableOrganization.details.createdAt',
    URL_PATH: 'systemSettings.disableOrganization.details.urlPath',
    TAX_ID: 'systemSettings.disableOrganization.details.taxId',
    TAX_ID_NONE: 'systemSettings.disableOrganization.details.taxIdNone',
    NOT_PROVIDED: 'systemSettings.disableOrganization.details.notProvided'
  },
  ADMINS: {
    TITLE: 'systemSettings.disableOrganization.admins.title',
    NONE: 'systemSettings.disableOrganization.admins.none',
    UNNAMED: 'systemSettings.disableOrganization.admins.unnamed',
    SHOWING_SOME: 'systemSettings.disableOrganization.admins.showingSome',
    LOAD_FAILED: 'systemSettings.disableOrganization.admins.loadFailed'
  },
  IMPACT: {
    TITLE: 'systemSettings.disableOrganization.impact.title',
    CAMPAIGNS: 'systemSettings.disableOrganization.impact.campaigns',
    DONATIONS: 'systemSettings.disableOrganization.impact.donations',
    TOTAL_RAISED: 'systemSettings.disableOrganization.impact.totalRaised',
    TOTAL_RAISED_PARTIAL: 'systemSettings.disableOrganization.impact.totalRaisedPartial',
    UNAVAILABLE: 'systemSettings.disableOrganization.impact.unavailable'
  },
  DISABLE_BUTTON: 'systemSettings.disableOrganization.disableButton',
  MODAL: {
    TITLE: 'systemSettings.disableOrganization.modal.title',
    WARNING: 'systemSettings.disableOrganization.modal.warning',
    CHECKBOX_LABEL: 'systemSettings.disableOrganization.modal.checkboxLabel',
    CONFIRM_BUTTON: 'systemSettings.disableOrganization.modal.confirmButton',
    CANCEL_BUTTON: 'systemSettings.disableOrganization.modal.cancelButton'
  },
  SUCCESS: 'systemSettings.disableOrganization.success',
  ERRORS: {
    LOAD_FAILED: 'systemSettings.disableOrganization.errors.loadFailed',
    LOAD_FAILED_HINT: 'systemSettings.disableOrganization.errors.loadFailedHint',
    LOAD_INCOMPLETE: 'systemSettings.disableOrganization.errors.loadIncomplete',
    DISABLE_FAILED: 'systemSettings.disableOrganization.errors.disableFailed'
  }
};
